import { render, staticRenderFns } from "./ArrowPad.vue?vue&type=template&id=10e5aa5b&scoped=true&lang=pug&"
import script from "./ArrowPad.vue?vue&type=script&lang=ts&"
export * from "./ArrowPad.vue?vue&type=script&lang=ts&"
import style0 from "./ArrowPad.vue?vue&type=style&index=0&id=10e5aa5b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e5aa5b",
  null
  
)

component.options.__file = "ArrowPad.vue"
export default component.exports